import block from "./block.js";
import component from "./component.js"

export default (editor, opts = {}) => {
  editor.DomComponents.addType("slideShowImage", component(opts));
  editor.BlockManager.add("slideShowImage", block(opts));
};